import canUse from './canUse'

const DeleteToken = () => canUse() && localStorage.removeItem('TOKEN')

export default DeleteToken
